import { CommissionType } from 'src/features/finance/commissionStatement/constants/commissionType';
import { enumToCamelCase } from 'src/lib/formatters';

export const getCommissionTypeHeading = (commissionType) => {
    let headingType = enumToCamelCase(CommissionType.TRANSACTION);
    if (commissionType.toLowerCase() === CommissionType.TERMINAL.toLowerCase()) {
        headingType = enumToCamelCase(CommissionType.TERMINAL);
    } else if (commissionType.toLowerCase() === CommissionType.ONLINE.toLowerCase()) {
        headingType = enumToCamelCase(CommissionType.ONLINE);
    }
    return headingType;
};

export default getCommissionTypeHeading;
